import {
  BitkitButton,
  BitkitIconButton,
  BitkitTextInput,
  BitkitTextInputProps,
  IconCheck,
  IconCopy,
  useResponsive,
} from '@bitrise/bitkit-v2';
import { useEffect, useState } from 'react';
import { useCopyToClipboard } from 'usehooks-ts';

type CopiableInputProps = BitkitTextInputProps & {
  hideButtonText?: boolean;
  copyActionText?: string;
};

const TIMEOUT = 1500;

const CopiableInput = ({ value = '', hideButtonText, copyActionText, size, ...rest }: CopiableInputProps) => {
  const [isCopied, setCopied] = useState(false);
  const [, copy] = useCopyToClipboard();
  const { isMobile } = useResponsive();

  useEffect(() => {
    const timeoutId = isCopied ? window.setTimeout(() => setCopied(false), TIMEOUT) : undefined;

    return () => clearTimeout(timeoutId);
  }, [isCopied]);

  const onClick = () => {
    if (value) {
      copy(value);
      setCopied(true);
    }
  };

  const copyButton =
    hideButtonText || isMobile ? (
      <BitkitIconButton
        label={isCopied ? 'Copied' : copyActionText || 'Copy to clipboard'}
        icon={isCopied ? IconCheck : IconCopy}
        onClick={onClick}
        size={size}
        variant="secondary"
      />
    ) : (
      <BitkitButton icon={isCopied ? IconCheck : IconCopy} onClick={onClick} size={size} variant="secondary">
        {isCopied ? 'Copied' : copyActionText || 'Copy'}
      </BitkitButton>
    );

  return <BitkitTextInput state="readOnly" {...rest} size={size} value={value} endAddon={copyButton} />;
};

export default CopiableInput;
